var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1C13.7761 1 14 1.22386 14 1.5V9H2V1.5C2 1.22386 2.22386 1 2.5 1H13.5ZM2.5 0C1.67157 0 1 0.671573 1 1.5V10H15V1.5C15 0.671573 14.3284 0 13.5 0H2.5Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5H16C16 11.3284 15.3284 12 14.5 12H1.5C0.671573 12 0 11.3284 0 10.5Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.967a7ff7145bb65c6de40f6a99ad7e59.svg";
export { ForwardRef as ReactComponent };